import axios from 'axios'
import responseInterceptorConfig from './interceptors/response.interceptor'
import getRequestInterceptorConfig from './interceptors/request.interceptor'

const createAxiosInstance = (config, iframeRoutes) => {
    if (!config.baseURL) {
        throw new Error('Axios: baseURL is required')
    }

    const defaultConfig = {
        timeout: 60_000,
        headers: { 'Content-Type': 'application/json' }
    }

    const axiosConfig = {
        ...defaultConfig,
        ...config
    }

    try {
        const instance = axios.create(axiosConfig)

        const controllers = {}

        const getController = () => {
            const path = window.location.pathname
            if (controllers[path] && !controllers[path].signal.aborted) {
                return controllers[path]
            }
            const ctrl = new AbortController()
            controllers[path] = ctrl
            return ctrl
        }

        const cancelPreviousRequests = path => {
            const ctrl = controllers[path]
            if (ctrl) {
                ctrl.abort()
                delete controllers[path]
            }
        }

        instance.interceptors.response.use(responseInterceptorConfig.onFulfilled, responseInterceptorConfig.onRejected)

        const requestInterceptorConfig = getRequestInterceptorConfig(getController, iframeRoutes)

        instance.interceptors.request.use(requestInterceptorConfig.onFulfilled, requestInterceptorConfig.onRejected)

        return { instance, cancelPreviousRequests }
    } catch (error) {
        console.error('Failed to create Axios instance', error)
        throw error
    }
}

export default createAxiosInstance
